import styled from 'styled-components';
import { colors, fontSizes } from '../../../defaultTheme';
export const BinartLabel = styled.label `
  display: inline-block;
  position: relative;
`;
export const BinartInlineWrapper = styled.span `
  font-size: ${fontSizes.root}px;
  text-align: center;
  color: ${({ isSelected, theme }) => isSelected ? theme.binart.background : colors.black};
`;
export const HiddenCheckbox = styled.input.attrs({
    type: 'checkbox'
}) `
  opacity: 0;
  position: absolute;
  display: block;
  margin: 0;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  top: 33px;
  &:focus-visible {
    outline: none;
  }
`;
export const BinartIconWrapper = styled.span `
  align-items: center;
  border-radius: 100%;
  box-sizing: border-box;
  display: flex;
  font-size: ${fontSizes.medium}px;
  height: 44px;
  justify-content: center;
  margin: 11px auto 7px auto;
  position: relative;
  text-align: center;
  width: 44px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  ${({ disabled, hasError, isSelected, theme }) => {
    if (hasError) {
        return `
        color: ${colors.error};
        border: 2px solid ${colors.error};
      `;
    }
    if (disabled) {
        return `
        color: ${theme.binart.background};
        border: 2px solid ${theme.binart.disableBorderColor};
        background-color: ${theme.binart.disableBackground};
      `;
    }
    if (isSelected) {
        return `
        color: ${colors.white};
        border: 2px solid ${theme.binart.background};
        background-color: ${theme.binart.background};
      `;
    }
    return `
        color: ${colors.doveGray};
        border: 2px solid ${colors.doveGray};
        background-color: ${colors.white};
      `;
}}

  ${HiddenCheckbox}:focus + & {
    outline: ${({ theme }) => theme.focus} auto 5px;
    outline-offset: 2px;
  }
`;
